import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Slider, Stack } from '@mui/material';
function sliderLabel(value) {
    return `${value}`;
}
const ScaleAnswer = ({ response, setResponse, disabled, }) => (_jsxs(Stack, { sx: {
        mt: 6,
        mb: 4,
        mx: 6,
    }, direction: "column", children: [_jsx(Slider, { "aria-label": "Scale", defaultValue: 1, step: 1, getAriaLabel: sliderLabel, valueLabelDisplay: "on", marks: true, min: 1, max: 10, value: parseInt(response || '1', 10), onChange: (ev, value) => setResponse(value.toString()), disabled: disabled }), _jsxs(Stack, { direction: "row", children: [_jsx(Box, { children: "1" }), _jsx(Box, { flexGrow: 1 }), _jsx(Box, { children: "10" })] })] }));
export default ScaleAnswer;
//# sourceMappingURL=ScaleAnswer.js.map